import { isHttpError, JsonApiRequestError } from '@farfetched/core';
import { createEffect, sample } from 'effector';
import { IS_DEV } from 'shared/config';
import { $t } from '../effector-i18next';
import { notifications } from '../effector-notifications';
import { isHttpErrorWithResponse, isNotHttpError, isUnauthorizedError } from './errors';
import { Operation } from './operation';

export const applyNotifications = (operation: Operation) => {
	const error = operation.finished.failure.map((args) => ({ error: args.error }));

	const httpError = sample({
		clock: error,
		filter: isHttpError,
	});

	const notHttpError = sample({
		clock: error,
		filter: isNotHttpError,
	});

	const httpErrorWithResponse = sample({
		clock: httpError,
		filter: isHttpErrorWithResponse,
	});

	const notUnauthorizedErrorWithResponse = sample({
		clock: httpErrorWithResponse,
		filter: (args) => !isUnauthorizedError(args),
	});

	const httpErrorWithoutResponse = sample({
		clock: httpError,
		filter: (args) => !isHttpErrorWithResponse(args),
	});

	const logErrorFx = createEffect((err: JsonApiRequestError) => {
		IS_DEV && console.error(`${err.errorType}: ${err.explanation}`, err);
	});

	sample({
		clock: error,
		fn: (args) => args.error,
		target: logErrorFx,
	});

	sample({
		clock: [notHttpError, httpErrorWithoutResponse],
		source: $t,
		fn: (t, args) => ({ message: t(`errors:request-messages.${args.error.errorType}`) }),
		target: notifications.showError,
	});

	sample({
		clock: notUnauthorizedErrorWithResponse,
		source: $t,
		fn: (t, args) => ({ message: t(`errors:http-messages.${args.error.response.message}`) }),
		target: notifications.showError,
	});
};
